module.exports = __webpack_public_path__ + "icon_done-12b87c12f915597dccbd2ca4d7167ba4.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_done.png
// module id = 272
// module chunks = 86